export const PORTAL_GRADIENT = "linear-gradient(90deg, #2d3e50 60%, #4b6cb7 100%)";

export const PORTAL_PRIMARY = "#4b6cb7";

export const PORTAL_ACCENT = "#3253dc";

export const PORTAL_HEADER_ICON = "#ffd700";

export const PORTAL_SOFT_BG = "#eef2fb";

export const PORTAL_SELECTED_BG = "#dbe4f7";

export const PORTAL_CHIP = {backgroundColor: "#e3ecff", color: "#2d3e50", fontWeight: 600};

export const PORTAL_BUCKET_CHIP = {backgroundColor: "#eef2fb", color: "#2d3e50", fontWeight: 600};

export const STATUS_CHIP_COLORS = {
    active: {backgroundColor: "#e6f4ea", color: "#1e7e34"},
    rotated: {backgroundColor: "#fff4e0", color: "#a05a00"},
    expired: {backgroundColor: "#eceff4", color: "#4d5b6b"},
    revoked: {backgroundColor: "#fdeaea", color: "#b3261e"},
};
